import React, { useState, useEffect, useMemo } from 'react';
import { Button, Drawer, Menu, Checkbox, Tag, Badge, Empty, Spin, Image, Divider } from 'antd';
import useZuStore from 'store/zustand/zustand-store';
import { useLocalStorageStateOfAiChatBot } from 'utils/react-hooks/cs-local-storage-hooks';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import scss from './AiDrawer.scss';
import gfm from 'remark-gfm';
import { isZh, ze } from 'utils/zhEn';
import ReactMarkdown from 'react-markdown';
import { LoadingOutlined } from '@ant-design/icons';
import AiReasoningStatusBlock from 'components/top/AiDrawer/AiReasoningStatusBlock';
import classNames from 'classnames';

const markdownComponents = {
  img({ node, ...props}) {
    return <div style={{ maxWidth:'100%' }}>
      <Image src={props.src} />
    </div>
  },
};

const AiChatBotBubble = ({
  messageId,
  conversationId,
  isBotNotUser,
  text,
  messageTimeInfo,
  childElement,
  customContentTextRenderer,
  isLoading,
}) => {
  const REASONING_START = '<think>';
  const REASONING_END = '</think>';

  const [isReasoning, setIsReasoning] = useState(false);
  const [isReasonCollapsed, setIsReasonCollapsed] = useState(false);

  const [reasoningText, contentText] = useMemo(() => {
    if (!text) {
      return ['', ''];
    }
    if (!isBotNotUser || typeof text !== 'string') {
      return ['', text];
    }
    const trimmedText = text.trim();
    if (trimmedText.startsWith(REASONING_START)) {
      const remainingText = trimmedText.substring(REASONING_START.length);
      const [before, ...afterList] = remainingText.split(REASONING_END);
      return [before.trim(), afterList.join(REASONING_END)];
    } else if (trimmedText.includes(REASONING_END)) { // 适配iGame自己的私有模型，只有推理结束标签没有开始标签
      const [before, ...afterList] = trimmedText.split(REASONING_END);
      return [before.trim(), afterList.join(REASONING_END)];
    } else {
      return ['', trimmedText];
    }
  }, [text]);

  useEffect(() => {
    if (reasoningText && !contentText) {
      setIsReasoning(true);
      setIsReasonCollapsed(false);
    } else {
      setIsReasoning(false);
      if (contentText) {
        setIsReasonCollapsed(true);
      }
    }
  }, [reasoningText, contentText]);

  let chatBubbleDom;

  if (isBotNotUser) {
    chatBubbleDom = <div className={scss.chatBubble} style={{ minHeight: 0 }}>
      { reasoningText && <div>
        <AiReasoningStatusBlock
          isReasoning={isReasoning}
          isCollapsed={isReasonCollapsed}
          onChangeCollapsed={(v) => setIsReasonCollapsed(v)}
        />
        { !isReasonCollapsed && <pre className={scss.reasoningContent}>
          <div>{ reasoningText }</div>
        </pre> }
      </div> }
      { contentText && !customContentTextRenderer && <div className={scss.clawMarkdownBody}>
        <ReactMarkdown
          remarkPlugins={[gfm]}
          linkTarget='_blank'
          children={contentText}
          components={markdownComponents}
        />
      </div> }
      { contentText && customContentTextRenderer && customContentTextRenderer(contentText) }
      { childElement }
      { isLoading && !contentText && <div><LoadingOutlined/><span style={{ marginLeft: '8px' }}>{ ze('数据准备中', 'Preparing data...')}</span></div> }
    </div>;
  } else {
    chatBubbleDom = <div style={{ display: 'flex', justifyContent: 'flex-end', minWidth: 0 }}>
      <div className={scss.chatBubbleUser} style={ customContentTextRenderer ? {} : { whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
        { customContentTextRenderer ? customContentTextRenderer(text) : text }
        { childElement }
      </div>
    </div>;
  }

  return <div className={scss.chatBubbleContainer}>
    { !!messageTimeInfo && <div style={ isBotNotUser ? {} : { textAlign: 'right' } }>
    { messageTimeInfo }
    </div> }
    { chatBubbleDom }
  </div>;
};

export default AiChatBotBubble;
